var map = {
	"./smImg1.png": 3810,
	"./smImg2.png": 4521,
	"./smImg3.png": 3344,
	"./smImg4.png": 4671,
	"./smImg5.png": 4694,
	"./smMinImg1.jpg": 2548,
	"./smMinImg2.jpg": 4355,
	"./smMinImg3.jpg": 3302,
	"./smMinImg4.jpg": 6653,
	"./smMinImg5.jpg": 3200
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7112;